import templateUrl from "emun.invoice/inv/inv-lines-header.htm";

export default () => ({ templateUrl });
